import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    Cookiebot?: any;
  }
}
const CONSENT_REGIONS = ['UK', 'DK', 'FR', 'IE','PT']; //Not applicable for Australia.

const CONSENTLANGUAGEMAP: Record<string, string> = {
  UK: 'en',
  DK: 'da',
  IE: 'en',
  FR: 'fr',
  PT: 'pt',
};

const needsConsent = (region: string) => CONSENT_REGIONS.includes(region);
const getConsentLanguage = (region: string) => CONSENTLANGUAGEMAP[region] || 'en';

export const useCookiebotManager = (region: string) => {
  const prevConsentRegion = useRef<string | null>(null);

  useEffect(() => {
    const consentNeeded = needsConsent(region);
    const language = getConsentLanguage(region);
    const prevLanguage = getConsentLanguage(prevConsentRegion.current || "");

    const scriptId = 'Cookiebot';
    const existingScript = document.getElementById(scriptId);

    /* Reading like this does not work.That's why used below logic.
      window?.Cookiebot?.consent?.given || false;*/
    const hasCookieConsentCookie = () =>
      document.cookie.includes("CookieConsent=");

    const isLanguageChanged = () =>
      prevLanguage !== language 

    const injectScript = () => {
      if (existingScript || window.Cookiebot) {
        if (!hasCookieConsentCookie() && window.Cookiebot?.show) {
          if (isLanguageChanged()) {
            removeScript(true);
            loadScript(language);
          }
          else if(needsConsent(prevConsentRegion.current||"")==false)
            loadScript(language);
          else
            window.Cookiebot.show();
        }
        return;
      }

      loadScript(language);

    };

    const loadScript = (language: string) => {
      const cookiebotId = process.env.REACT_APP_CONSENT_COOKIEBOT_ID || "";
      const script = document.createElement('script');

      script.id = scriptId;
      script.src = `https://consent.cookiebot.com/uc.js?t=${Date.now()}`;
      script.setAttribute('data-cbid', cookiebotId);
      script.async = true;
      script.setAttribute('data-culture', language);
      document.head.appendChild(script);

      script.onload = () => {
        if (!hasCookieConsentCookie() && window.Cookiebot?.show) {
          window.Cookiebot.show();
        }
      };
    }

    const removeScript = (isLanguageChanged: boolean) => {
      if (isLanguageChanged) {  //Removing script in else part did not work for this scenario.
        //Dynamic re init is not possible when language has to be changed.Hence has to reload
        window.location.reload();
      }
      else {
        if (existingScript) {
          existingScript.remove();
        }
        //This code is required to hide the banner when moving from consent(consent not provided) to non consent region.
        window.Cookiebot.hide()
      }
    };

    const prevRegion = prevConsentRegion.current;
    const prevNeedsConsent = prevRegion ? needsConsent(prevRegion) : null;

    if (consentNeeded) {
      injectScript();
    } else if (prevNeedsConsent) {
      // Need to remove the script because we should not show the consent banner when we move from consent region(consent was not provided) to no consent region
      removeScript(false);
    }

    prevConsentRegion.current = region;
  }, [region]);

};
